export const MenuIcon = () => {
    return (
        <>
            <title>Menu</title>
            <path d="M120-240v-80h720v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z" />
        </>
    );
};
